// eslint-disable-next-line @typescript-eslint/triple-slash-reference -- application tsc follows this file and needs the Vite ?url module type
/// <reference path="./pdfjs-worker-url.d.ts" />
import workerUrl from "pdfjs-dist/build/pdf.worker.min.mjs?url";

let configurePromise: Promise<void> | null = null;

/**
 * PDF.js must run its worker from a blob: URL. Applicant portal CSP
 * worker-src allows blob: but not 'self', so a bundled /assets worker
 * path would be blocked in production.
 *
 * Import the worker with ?url (not ?raw) so Vite emits it as a separate
 * asset instead of inlining the source, which OOMs the applicant-portal
 * preview build.
 */
export function configurePdfjsWorker(): Promise<void> {
  if (configurePromise) {
    return configurePromise;
  }

  configurePromise = (async () => {
    if (typeof URL.createObjectURL !== "function") {
      return;
    }

    const response = await fetch(workerUrl);
    if (!response.ok) {
      throw new Error(`Failed to fetch PDF.js worker: ${response.status}`);
    }
    const workerSource = await response.blob();
    const workerBlob =
      workerSource.type === "text/javascript" ||
      workerSource.type === "application/javascript"
        ? workerSource
        : new Blob([await workerSource.arrayBuffer()], {
            type: "text/javascript",
          });
    const pdfjs = await import("pdfjs-dist");
    pdfjs.GlobalWorkerOptions.workerSrc = URL.createObjectURL(workerBlob);
  })();

  configurePromise.catch(() => {
    configurePromise = null;
  });

  return configurePromise;
}
